import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Dropdown } from 'foundations-components/transitional/components/Dropdown';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { Button } from 'trellis-story-utils/doc-blocks/Button';
import { useAppContext } from '../../context/AppContext';
import { getConnectedAppUrl, getMarketplaceDownloadsUrl } from '../../utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function ManageBuildDropdowns() {
  return /*#__PURE__*/_jsxs(Flex, {
    gap: "500",
    insetBlockStart: "28px",
    insetInlineEnd: "0",
    position: "absolute",
    children: [/*#__PURE__*/_jsx(ManageDropdown, {}), /*#__PURE__*/_jsx(BuildDropdown, {})]
  });
}
function ManageDropdown() {
  const appContext = useAppContext();
  if (appContext !== 'app') return undefined;
  return /*#__PURE__*/_jsx(Dropdown, {
    buttonUse: "unstyled",
    buttonText: /*#__PURE__*/_jsx(Text, {
      color: "text-core-subtle",
      typography: "body-100",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplaceStorefront.headers.manage"
      })
    }),
    gap: "200",
    menuWidth: 200,
    placement: "bottom",
    children: /*#__PURE__*/_jsxs(List, {
      children: [/*#__PURE__*/_jsx(ListItem, {
        children: /*#__PURE__*/_jsx(Button, {
          href: getConnectedAppUrl(appContext),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplaceStorefront.headers.dropdown.connectedApps"
          })
        })
      }), /*#__PURE__*/_jsx(ListItem, {
        children: /*#__PURE__*/_jsx(Button, {
          href: getMarketplaceDownloadsUrl(appContext),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplaceStorefront.headers.dropdown.templates"
          })
        })
      })]
    })
  });
}
function BuildDropdown() {
  return /*#__PURE__*/_jsx(Dropdown, {
    buttonUse: "unstyled",
    buttonText: /*#__PURE__*/_jsx(Text, {
      color: "text-core-subtle",
      typography: "body-100",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplaceStorefront.headers.build"
      })
    }),
    gap: "200",
    menuWidth: 200,
    placement: "bottom",
    children: /*#__PURE__*/_jsx(List, {
      children: /*#__PURE__*/_jsx(ListItem, {
        children: /*#__PURE__*/_jsx(Button, {
          href: "https://developers.hubspot.com/",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplaceStorefront.headers.dropdown.apps"
          })
        })
      })
    })
  });
}